"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ConfigProvider: ()=>ConfigProvider,
    ConfigContext: ()=>ConfigContext,
    useConfig: ()=>useConfig
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const displayConfig_js_namespaceObject = require("../config/displayConfig.js");
const featureConfig_js_namespaceObject = require("../config/featureConfig.js");
const payloadConfig_js_namespaceObject = require("../config/payloadConfig.js");
const serviceConfig_js_namespaceObject = require("../config/serviceConfig.js");
const getHostingApp_js_namespaceObject = require("../utils/getHostingApp.js");
const ConfigContext = /*#__PURE__*/ (0, external_react_namespaceObject.createContext)({
    resolvedConfig: void 0,
    resolvedDisplay: void 0,
    resolvedFeatures: void 0,
    resolvedPayload: void 0
});
const useConfig = ()=>{
    const context = (0, external_react_namespaceObject.useContext)(ConfigContext);
    if (!context) throw new Error('useConfig must be used within a ConfigProvider');
    return context;
};
const ConfigProvider = ({ children, customerName, isChatBoxOpened, locale, startingChatMessagesPayload, viewType: viewTypeProp, webstats, logAnalytics })=>{
    const viewTypeFromWebApp = viewTypeProp || (0, getHostingApp_js_namespaceObject.getHostingApp)();
    const [resolvedConfig, setResolvedConfig] = (0, external_react_namespaceObject.useState)(void 0);
    const [resolvedDisplay, setResolvedDisplay] = (0, external_react_namespaceObject.useState)(void 0);
    const [resolvedFeatures, setResolvedFeatures] = (0, external_react_namespaceObject.useState)(void 0);
    const [resolvedPayload, setResolvedPayload] = (0, external_react_namespaceObject.useState)(void 0);
    (0, external_react_namespaceObject.useEffect)(()=>{
        const processConfig = (viewTypeFromWebApp)=>{
            const isMobile = 'boolean' == typeof webstats?.isMobile ? webstats.isMobile : false;
            const payload = (0, payloadConfig_js_namespaceObject.getPayloadConfig)({
                isChatBoxOpened,
                customerName,
                locale,
                startingChatMessagesPayload,
                viewType: viewTypeFromWebApp,
                webstats
            });
            setResolvedPayload(payload);
            setResolvedConfig((0, serviceConfig_js_namespaceObject.getServiceConfig)(viewTypeFromWebApp, isMobile, customerName, logAnalytics));
            setResolvedDisplay((0, displayConfig_js_namespaceObject.getDisplayConfig)(viewTypeFromWebApp, isMobile));
            setResolvedFeatures((0, featureConfig_js_namespaceObject.getFeatureConfig)(viewTypeFromWebApp, isChatBoxOpened));
        };
        processConfig(viewTypeFromWebApp);
    }, [
        isChatBoxOpened,
        viewTypeFromWebApp,
        customerName,
        webstats
    ]);
    if (!resolvedConfig || !resolvedDisplay || !resolvedFeatures || !resolvedPayload) return null;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ConfigContext.Provider, {
        value: {
            resolvedConfig,
            resolvedDisplay,
            resolvedFeatures,
            resolvedPayload
        },
        children: 'function' == typeof children ? children(resolvedConfig, resolvedDisplay, resolvedFeatures, resolvedPayload) : children
    });
};
exports.ConfigContext = __webpack_exports__.ConfigContext;
exports.ConfigProvider = __webpack_exports__.ConfigProvider;
exports.useConfig = __webpack_exports__.useConfig;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ConfigContext",
    "ConfigProvider",
    "useConfig"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
